"use client";

import { useEffect, useRef } from "react";

const partners = [
  "University of Melbourne",
  "UNSW Sydney",
  "Monash University",
  "University of Edinburgh",
  "King's College London",
  "UCL",
  "TU Munich",
  "University of Amsterdam",
  "Politecnico di Milano",
  "Delft University",
  "ANU",
  "University of Manchester",
  "University of Groningen",
  "Macquarie University",
];

export default function MarqueeSection() {
  const trackRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    let x = 0;
    let raf: number;
    const speed = 0.6;
    const totalWidth = track.scrollWidth / 2;

    const animate = () => {
      x -= speed;
      if (Math.abs(x) >= totalWidth) x = 0;
      track.style.transform = `translateX(${x}px)`;
      raf = requestAnimationFrame(animate);
    };

    raf = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(raf);
  }, []);

  const items = [...partners, ...partners];

  return (
    <section className="py-10 overflow-hidden border-y border-crimson-100 bg-parchment">
      <div className="flex items-center gap-4 mb-0">
        <div className="flex-shrink-0 px-8">
          <p className="text-xs font-bold text-ink-muted uppercase tracking-widest whitespace-nowrap">
            Partner Universities
          </p>
        </div>
        <div className="overflow-hidden flex-1">
          <div ref={trackRef} className="flex gap-12 whitespace-nowrap will-change-transform">
            {items.map((name, i) => (
              <div key={`${name}-${i}`} className="flex items-center gap-4 flex-shrink-0">
                <span className="text-sm font-semibold text-ink/50 hover:text-crimson transition-colors cursor-default">
                  {name}
                </span>
                <span className="w-1 h-1 rounded-full bg-crimson/30 flex-shrink-0" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}